import apiSlice from 'renderer/shared/state/apiSlice';

export const productImagesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    // List all product images (metadata only)
    listProductImages: build.query<
      { _id: string; filename: string; contentType: string }[],
      void
    >({
      query: () => '/product-images',
      providesTags: ['ProductImages'],
    }),

    // Upload new image (just uses original filename)
    uploadProductImage: build.mutation<any, { file: File }>({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: '/product-images',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['ProductImages'],
    }),

    // Delete image by ID
    deleteProductImage: build.mutation<void, string>({
      query: (id) => ({
        url: `/product-images/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ProductImages'],
    }),
  }),
});

export const {
  useListProductImagesQuery,
  useUploadProductImageMutation,
  useDeleteProductImageMutation,
} = productImagesApi;
